import { camelCase } from 'lodash';

export class VehicleIcon {
  iconId: number = null;
  iconLocation: string = null;
  iconName: string = null;

  constructor(obj?: any) {
    for (const field in obj) {
      const camelCasedField = camelCase(field);
      if (typeof this[camelCasedField] !== 'undefined') {
        this[camelCasedField] = obj && obj[field];
      }
    }
  }
}
